import { ApiService } from "../api.service";
import { CommonService } from "../common.service";
import { ActivatedRoute, Router } from "@angular/router";
var CasePracticeAuthorizationQuestionComponent = (function () {
    function CasePracticeAuthorizationQuestionComponent(commonService, apiService, route, router) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.route = route;
        this.router = router;
        this.assetsRoute = "../../assets";
    }
    CasePracticeAuthorizationQuestionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.apiService.ajax({
            'type': 'get',
            'url': '/api/taskBook/' + this.exerciseId
        }).subscribe(function (result) {
            _this.taskBook = result;
        });
    };
    CasePracticeAuthorizationQuestionComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            'backgroundColor': 'white'
        });
        this.questionInit();
    };
    CasePracticeAuthorizationQuestionComponent.prototype.questionInit = function () {
        var _this = this;
        this.apiService.ajax({
            'type': 'get',
            'url': '/api/authQuestion/' + this.exerciseId
        }).subscribe(function (result) {
            _this.tell = result.concatenation;
            _this.questions = result.questions;
            _this.completedQuestions = result.completed;
            _this.currentOption = '';
            if (_this.completedQuestions.length < _this.questions.length) {
                _this.tellWrapShow = false;
                _this.currentQuestionNumber = _this.completedQuestions.length;
                _this.currentQuestion = _this.questions[_this.currentQuestionNumber].title;
                _this.currentRightAnswer = _this.questions[_this.currentQuestionNumber].answer;
                _this.questionBtnMode = 1;
                _this.showAnswer = false;
                _this.selectedAble = true;
            }
            else {
                _this.tellWrapShow = true;
            }
        });
    };
    CasePracticeAuthorizationQuestionComponent.prototype.onOptionClick = function (i) {
        if (!this.selectedAble) {
            return;
        }
        if (i == 0) {
            this.currentOption = '要交代';
        }
        else {
            this.currentOption = '不该说';
        }
    };
    CasePracticeAuthorizationQuestionComponent.prototype.onQuestionBtnClick = function () {
        if (this.currentOption == '') {
            return;
        }
        if (this.questionBtnMode == 1) {
            if (this.currentQuestionNumber < this.questions.length - 1) {
                this.questionBtnMode = 2;
            }
            else {
                this.questionBtnMode = 3;
            }
            this.showAnswer = true;
            this.selectedAble = false;
            this.apiService.ajax({
                'type': 'post',
                'url': '/api/authQuestion/' + this.exerciseId,
                'data': {
                    'authquestion_id': this.questions[this.currentQuestionNumber].id,
                    'isTrue': this.currentOption == this.currentRightAnswer ? 1 : 2
                }
            }).subscribe(function (result) {
            });
        }
        else if (this.questionBtnMode == 2) {
            this.currentOption = '';
            this.currentQuestionNumber++;
            this.currentQuestion = this.questions[this.currentQuestionNumber].title;
            this.currentRightAnswer = this.questions[this.currentQuestionNumber].answer;
            this.questionBtnMode = 1;
            this.showAnswer = false;
            this.selectedAble = true;
        }
        else if (this.questionBtnMode == 3) {
            /*$('#questionWrap').fadeOut(200);
            setTimeout(function () {
                $('#tellWrap').fadeIn(200);
            },500);*/
            this.tellWrapShow = true;
        }
    };
    CasePracticeAuthorizationQuestionComponent.prototype.taskBookOut = function ($event) {
        $event.stopPropagation();
        $('#shade').fadeIn(50);
        $('#taskBookBox').fadeIn();
        $('#closeBtn').fadeIn();
    };
    CasePracticeAuthorizationQuestionComponent.prototype.closeTip = function ($event) {
        $event.stopPropagation();
        $('#shade').fadeOut();
        $('#taskBookBox').fadeOut();
        $('#closeBtn').fadeOut();
        // 恢复点击功能
    };
    CasePracticeAuthorizationQuestionComponent.prototype.goToMain = function () {
        this.commonService.setOnceIno(this.commonService.getOnceValue(this.exerciseMetaId, 704)).subscribe();
        var link = ['case-practice-authorization-main', this.learningPathId, this.practiceId, this.exerciseId];
        if (this.type) {
            this.router.navigate(link, { queryParams: { type: 'huatek' } });
        }
        else {
            this.router.navigate(link);
        }
    };
    return CasePracticeAuthorizationQuestionComponent;
}());
export { CasePracticeAuthorizationQuestionComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-authorization-question/case-practice-authorization-question.component.ts.pre-build-optimizer.js